import { render } from "./PostPassportHistory.vue?vue&type=template&id=b89f5916&scoped=true"
import script from "./PostPassportHistory.vue?vue&type=script&lang=js"
export * from "./PostPassportHistory.vue?vue&type=script&lang=js"

import "@/assets/table.css?vue&type=style&index=0&id=b89f5916&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b89f5916"]])

export default __exports__